import { NgForOf } from '@angular/common';
import { AfterViewInit, Component, Input, Renderer2 } from '@angular/core';
import { GlobalService } from '@app/core/services/common/global.service';
import { Block } from '@core/models/block/block.model';
import { mergeStyles } from '@shared/helpers/style-helpers';
import { buildEmbedIframe, resolveEmbedUrl } from './iframe-code-embed';

@Component({
  selector: 'app-iframe-code',
  templateUrl: './iframe-code.component.html',
  styleUrls: ['./iframe-code.component.scss'],
  imports: [
    NgForOf,
  ],
})
export class IframeCodeComponent implements AfterViewInit {
  @Input() item: any;
  @Input() styleIfameParent: any;
  valueIframe = {};

  constructor(
    private renderer: Renderer2,
    private globalService: GlobalService,
  ) {
  }

  getContainerId(index: number): string {
    const parts = ['embed-container'];
    parts.push(this.item.uId);
    if (this.item.modelId) {
      parts.push(this.item.modelId);
    }
    parts.push(`${index}`);

    return parts.join('-');
  }

  ngAfterViewInit(): void {
    this.restartStyle(this.item, 'block');
    this.item.children.forEach((item: Block, index: number) => {
      this.processContent(item, index);
    });
    this.globalService.mediaQuery.subscribe(() => {
      this.restartStyle(this.item, 'block');
      this.item.children.forEach((item: Block, index: number) => {
        this.processContent(item, index);
      });
    });
  }

  restartStyle(item: Block, index?: any) {
    if (index === 'block') {
      const elementsInputEnd = document.querySelectorAll('.block');
      const style = mergeStyles(this.globalService.styleIfameParent, 'basic').basic;
      for (const key in style) {
        elementsInputEnd.forEach(element => {
          if (key != 'aspectRatio') {
            this.renderer.setStyle(element, this.camelToKebabCase(key), style[key]);
          }
        });
      }
    } else {
      const embedContainer = document.getElementById(this.getContainerId(index));
      // AT-9147: element budujemy przez DOM z zwalidowanego adresu, bez innerHTML.
      embedContainer.replaceChildren();
      const embedUrl = this.valueIframe[`${item.uId}`];
      if (embedUrl) {
        embedContainer.appendChild(buildEmbedIframe(document, embedUrl));
      }
      embedContainer.style.width = '100%';
      embedContainer.style.height = '100%';
      const iframe = embedContainer.querySelector('iframe');
      if (iframe) {
        iframe.style.width = 'inherit';
        iframe.style.height = 'inherit';

      }
      const blockChild = document.querySelectorAll('.blockChild');
      const style = mergeStyles(item.styles, 'basic').basic;
      for (const key in style) {
        blockChild.forEach(element => {
          (element as HTMLElement).style.setProperty(this.camelToKebabCase(key), style[key], 'important');
        });
      }
    }
  }

  processContent(block: Block, index: number) {
    if (!block.content) {
      return true;
    }

    const embedUrl = resolveEmbedUrl(block.content);
    if (embedUrl) {
      this.valueIframe[`${block.uId}`] = embedUrl;
      this.restartStyle(block, index);
    }
  }

  camelToKebabCase(str: string): string {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }

}
